export const UPCOMING_EVENTS_TOUR_KEY = 'upcoming-events';

export const upcomingEventsTourSteps = [
  {
    target: 'upcoming-events-list',
    title: 'Spieltage-Liste',
    description: 'Hier siehst du alle Spieltage. Der Status (z. B. "Ausstehend", "Abgeschlossen") wird automatisch gesetzt.',
  },
  {
    target: 'upcoming-events-list',
    title: 'Kurzer Klick → Anwesenheitsliste',
    description: 'Ein kurzer Klick auf einen Spieltag öffnet die Anwesenheitsliste für diesen Tag.',
  },
  {
    target: 'upcoming-events-list',
    title: 'Langer Klick → Kontextmenü',
    description: 'Halte einen Spieltag gedrückt, um das Kontextmenü zu öffnen. Über "Statistiken" siehst du Einnahmen, Kosten und Netto des Spieltags — solange er noch nicht abgeschlossen ist, als Vorschau.',
  },
];
